import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";
import qs from "qs";

var Email =
/*#__PURE__*/
function () {
  function Email() {
    _classCallCheck(this, Email);
  }

  _createClass(Email, [{
    key: "SendEmail",
    value: function () {
      var _SendEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(emailId, who, email, subject, body, textBody, attachmentName, attachment) {
        var data, i, request;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = new FormData();
                data.append("emailId", emailId);
                data.append("who", who);
                email.forEach(function (x) {
                  return data.append("contactTypeIds[]", x.value);
                });
                data.append("subject", subject);
                data.append("message", body);
                data.append("textBody", textBody);

                for (i = 0; i < attachment.length; i++) {
                  data.append("attachments[]", attachment[i]);
                  data.append("attachmentNames[]", attachmentName[i]);
                }

                _context.next = 10;
                return axios({
                  method: "post",
                  url: "/api/EmailData",
                  headers: {
                    "Content-Type": "multipart/form-data"
                  },
                  data: data
                });

              case 10:
                request = _context.sent;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function SendEmail(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
        return _SendEmail.apply(this, arguments);
      }

      return SendEmail;
    }()
  }, {
    key: "GetWhoData",
    value: function () {
      var _GetWhoData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var request;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                request = axios({
                  method: "get",
                  url: "/api/PropertyQuery"
                });
                return _context2.abrupt("return", request);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function GetWhoData() {
        return _GetWhoData.apply(this, arguments);
      }

      return GetWhoData;
    }()
  }, {
    key: "GetContactTypes",
    value: function () {
      var _GetContactTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var request;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                request = axios({
                  method: "get",
                  url: "/api/ContactTypes"
                });
                return _context3.abrupt("return", request);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetContactTypes() {
        return _GetContactTypes.apply(this, arguments);
      }

      return GetContactTypes;
    }()
  }, {
    key: "GetTemplateList",
    value: function () {
      var _GetTemplateList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var request;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                request = axios({
                  method: "get",
                  url: "/api/EmailTemplates"
                });
                return _context4.abrupt("return", request);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function GetTemplateList() {
        return _GetTemplateList.apply(this, arguments);
      }

      return GetTemplateList;
    }()
  }, {
    key: "GetTemplateData",
    value: function () {
      var _GetTemplateData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(givenId) {
        var data, request;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                data = new FormData();
                data.append("emailId", givenId);
                request = axios({
                  method: "post",
                  url: "/api/EmailTemplate",
                  headers: {
                    "Content-Type": "multipart/form-data"
                  },
                  data: data
                });
                return _context5.abrupt("return", request);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function GetTemplateData(_x9) {
        return _GetTemplateData.apply(this, arguments);
      }

      return GetTemplateData;
    }()
  }, {
    key: "SetActivatedProp",
    value: function () {
      var _SetActivatedProp = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(emailId, activated) {
        var data, request;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = new FormData();
                data.append("emailId", emailId);
                data.append("activated", activated);
                request = axios({
                  method: "post",
                  url: "/api/EmailSetActivatedProp",
                  headers: {
                    "Content-Type": "multipart/form-data"
                  },
                  data: data
                });
                return _context6.abrupt("return", request);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function SetActivatedProp(_x10, _x11) {
        return _SetActivatedProp.apply(this, arguments);
      }

      return SetActivatedProp;
    }()
  }, {
    key: "saveTemplate",
    value: function () {
      var _saveTemplate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(name, description, who, subject, EmailBody, typeIds, emailId, attachmentName, attachment, scheduleData, additionalParameters, userIds, sendToCreatedBy, sendToMcAdmin, sendToCertifiedBy) {
        var data, i, request;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                data = new FormData();
                data.append("name", name);
                data.append("description", description);
                data.append("who", who);
                data.append("subject", subject);
                data.append("EmailBody", EmailBody);
                if (additionalParameters) additionalParameters.forEach(function (x) {
                  return data.append("additionalParameters[]", x);
                });
                typeIds.forEach(function (x) {
                  return data.append("typeIds[]", x);
                });
                userIds.forEach(function (x) {
                  return data.append("userIds[]", x);
                });
                data.append("sendToCreatedBy", sendToCreatedBy);
                data.append("sendToMcAdmin", sendToMcAdmin);
                data.append("sendToCertifiedBy", sendToCertifiedBy);

                for (i = 0; i < attachment.length; i++) {
                  data.append("attachments[]", attachment[i]);
                  data.append("attachmentNames[]", attachmentName[i]);
                }

                scheduleData.forEach(function (x) {
                  return data.append("scheduleData[]", x.Schedule);
                });
                scheduleData.forEach(function (x) {
                  return data.append("scheduleRepeat[]", x.Repeat);
                });
                scheduleData.forEach(function (x) {
                  return data.append("scheduleActive[]", x.Active);
                });
                scheduleData.forEach(function (x) {
                  return data.append("scheduleType[]", x.TypeId);
                });
                data.append("givenEmailId", emailId);
                request = axios({
                  method: "post",
                  url: "/api/SaveTemplate",
                  headers: {
                    "Content-Type": "multipart/form-data"
                  },
                  data: data
                });
                return _context7.abrupt("return", request);

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function saveTemplate(_x12, _x13, _x14, _x15, _x16, _x17, _x18, _x19, _x20, _x21, _x22, _x23, _x24, _x25, _x26) {
        return _saveTemplate.apply(this, arguments);
      }

      return saveTemplate;
    }()
  }, {
    key: "Preview",
    value: function () {
      var _Preview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(propetyQuery, contactTypeId, additionalQueryParameters, message) {
        var request;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                request = axios({
                  method: "get",
                  url: "/api/Email/Preview",
                  params: {
                    propetyQuery: propetyQuery,
                    contactTypeId: contactTypeId,
                    additionalQueryParameters: additionalQueryParameters,
                    message: message
                  },
                  doNotShowLoading: true
                });
                return _context8.abrupt("return", request);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function Preview(_x27, _x28, _x29, _x30) {
        return _Preview.apply(this, arguments);
      }

      return Preview;
    }()
  }, {
    key: "GetRecipients",
    value: function () {
      var _GetRecipients = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(propetyQuery, contactTypeId, additionalQueryParameters) {
        var request;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                request = axios({
                  method: "get",
                  url: "/api/Email/GetRecipients",
                  params: {
                    propetyQuery: propetyQuery,
                    contactTypeId: contactTypeId,
                    additionalQueryParameters: additionalQueryParameters
                  },
                  doNotShowLoading: true,
                  paramsSerializer: function paramsSerializer(params) {
                    return qs.stringify(params, {
                      arrayFormat: "repeat"
                    });
                  }
                });
                return _context9.abrupt("return", request);

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function GetRecipients(_x31, _x32, _x33) {
        return _GetRecipients.apply(this, arguments);
      }

      return GetRecipients;
    }()
  }]);

  return Email;
}();

export default new Email();